// ajaxContent

//returning json format
// {
//  hideTrigger: false, //true will .hide() trigger element
//  stopLoading: false, //disables loading more content if true
//  ajaxUrl: '', //updated the ajax url for next call (can be used for simple paging)
//  html: '', //html to put in the results using result option
//  update: [{ //used to update optional elements
//    selector: '',
//    html: '', //replaces current html with this
//  }],
//  error: false, //true if error
//  errorMessage: '', //message to show if there is an error
// }
//

bq.ajaxContent = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.active    = false;
  this.ignore    = false;
  this.$trigger  = false;
  this.$target   = false;
};

bq.ajaxContent.DEFAULTS = {
  target: false, //required
  results: 'append', //append, prepend, replace
  response: 'json', //json, html (only replace is available for html)
  trigger: '.ajax-content-trigger',
  triggerEvent: 'click',
  ajaxUrl: false //if not set, uses href on trigger
};

bq.ajaxContent.prototype = {

  init: function(opt) {
    bq.debug.log("ajaxContent : init()", this.$element);

    this.$trigger = this.$element.find(this.options.trigger);
    this.$target = this.$element.find(this.options.target);

    if(this.$trigger.length <= 0) {
      //no trigger
      bq.debug.warn("ajaxContent : trigger not available", this);
      return;
    }

    if(this.$target.length <= 0) {
      this.$target = this.$element; //if no trigger, just use main el, so we can just use events to load content
    }

    if(this.options.ajaxUrl.length <= 0) {
      this.options.ajaxUrl = this.$trigger.attr('href') ? this.$trigger.attr('href') : this.$trigger.data('ajaxUrl');

      if(this.options.ajaxUrl.length <= 0) {
        bq.debug.error("ajaxContent : required data-* missing", this);
        return;
      }
    }

    this.$trigger.on(this.options.triggerEvent, {context:this}, this._catchTrigger);

  },

  _loadData: function() {

    if(this.active || this.ignoreProccessing) { return false; }

    var $this = this;

    this._throwEventLoadStart();
    this._disable();

    if(this.options.response == 'html') {
      this.$target.load(this.options.ajaxUrl, {ajax: true}, function(response, status, xhr){
          $this._enable();
          $this._throwEventLoadEnd();
          if ( status == "error" ) {
            $this._showError(false);
            var err = status + ", " + respnse;
            bq.debug.error("ajaxContent : loadData : ajax error : " + err, this);
          }
       });
    } else {
      $.getJSON( this.options.ajaxUrl, {ajax: true} )
        .done(function( json ) {
            if(json.error === true || json.error === 'true') {
              $this._showError(json.errorMessage);
              return;
            }

            $this._processJson(json);

          })
        .fail(function( jqxhr, textStatus, error ) {
            $this._showError(false);
            var err = textStatus + ", " + error;
            bq.debug.error("ajaxContent : loadData : ajax error : " + err, this);
          })
        .always(function(data, textStatus, jqXHR) {
            $this._enable();
            $this._throwEventLoadEnd();
          });

    }
  },

  _processJson: function(json) {
    var $this = this;

    if(json.stopLoading === true || json.stopLoading == 'true') { this.ignore = true; }
    if(json.hideTrigger === true || json.hideTrigger == 'true') { this.$trigger.hide(); }
    if(json.ajaxUrl && json.ajaxUrl.length >= 1) { this.options.ajaxUrl = json.ajaxUrl.replace( /\&amp;/g, '&' ); }

    if(json.html && json.html.length >= 1) {
      switch($this.options.results) {
        case 'prepend':
          $this.$target.prepend(json.html);
          break;
        case 'append':
          $this.$target.append(json.html);
          break;
        default:
          $this.$target.html(json.html);
          break;
      }
    }

    if(json.update) {
      $.each(json.update, function(key, el) {
        $(el.selector).html(el.html);
      });
    }

  },

  _catchTrigger: function(e) {
    var $this = e.data.context;
    $this._loadData();
    return false;

  },

  _showError: function(message) { //if false, we dont have a message

  },

  disable: function(disable) {
    if(disable) {
      this.$trigger.prop('disabled', true).addClass('disabled');
    } else {
      this.$trigger.prop('disabled', false).removeClass('disabled');
    }
  },

  _disable: function() {
    this.active = true;
    this.disable(true);
  },

  _enable: function() {
    this.active = false;
    this.disable(false);
  },

  _throwEventLoadStart: function() {
    bq.debug.log("ajaxContent : event thrown [bq.ajaxContent.loadStart]");
    this.$element.trigger('bq.ajaxContent.loadStart', this);
  },

  _throwEventLoadEnd: function() {
    bq.debug.log("ajaxContent : event thrown [bq.ajaxContent.loadEnd]");
    this.$element.trigger('bq.ajaxContent.loadEnd', this);
  }


};


// ajaxContent PLUGIN DEFINITION
// =======================

var ajaxContentold = $.fn.ajaxContent;

$.fn.ajaxContent = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.ajaxContent');
    var options = $.extend({}, bq.ajaxContent.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.ajaxContent', (data = new bq.ajaxContent(this, options))); }
    data.init();
  });
};

$.fn.ajaxContent.Constructor = bq.ajaxContent;

// ajaxContent NO CONFLICT
// =================

$.fn.ajaxContent.noConflict = function () {
  $.fn.ajaxContent = ajaxContentold;
  return this;
};

// ajaxContent DATA-API
// ==============
bq.ajaxContentInit = function() {
    $('[data-bq="ajaxcontent"]').each(function () {
      var el = $(this);
      if(el.data('bq.ajaxContent')) { return; }
      el.ajaxContent(el.data());
    });
};

bq.init.push(bq.ajaxContentInit);
